import type { Styles } from 'src/theme/themes';

export const styles = {
  filterColumn: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    gap: 2,
    width: '100%',
  },
  filterSectionPopover: (theme) => ({
    marginTop: theme.spacing(2),
  }),
  filterSectionDropdown: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '14rem',
    flexGrow: 1,
    flexShrink: 1,
    border: '4px solid white',
    overflow: 'scroll',
  },
  openFilterGroupButton: (theme) => ({
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: theme.colors.neutral[50],
    color: theme.colors.neutral[500],
  }),
  openFilterGroupButtonLabel: (theme) => ({
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    fontWeight: theme.typography.fontWeightBold,
  }),
  filterColumnSection: (theme) => ({
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    borderBottomColor: theme.colors.neutral[200],
    py: theme.spacing(2),
    px: theme.spacing(3),
  }),
} satisfies Styles;
